/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { CustomLink } from "../custom-link";
import "./story-tags.module.css";

function Tag({ tag, urlPrefix = "" }) {
  return (
    <CustomLink href={`${urlPrefix}/topic/` + tag.slug} styleName="tag">
      {tag.name}
    </CustomLink>
  );
}

Tag.propTypes = {
  tag: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string
  }),
  urlPrefix: PropTypes.string
};

function StoryTags({ tags, config }) {
  const mountAtPrefix = config.mountAt || "";
  return (
    <div>
      {tags.map((tag, index) => (
        <Tag key={index} tag={tag} urlPrefix={mountAtPrefix} />
      ))}
    </div>
  );
}

StoryTags.propTypes = {
  tags: PropTypes.array,
  config: PropTypes.object
};

export { StoryTags };
